import { useApi } from '@backstage/core-plugin-api';
import { CustomViewRegister } from './registry';
import { customAlertApiRef } from '../../apis';
import { useEffect, useState } from 'react';
import MyErrorBoundary from './ErrorBoundary';
import { CustomError } from '@agilelab/plugin-wb-platform-common';

export const CustomViewComponentContent = (props: Record<string, any>) => {
  const subComponent = CustomViewRegister.get(props.type);
  if (subComponent) return subComponent(props);
  throw new Error(`Component type ${props.type} not found `);
};

export type CustomViewComponentProps = {
  type: string;
  // used to disable nunjucks processing of props, e.g. when creaating components dynamically (their templates would have skipped loading and fail)
  __disableNunjucksProcessing?: boolean;
} & Record<string, any>;

export const CustomViewComponent: React.FC<
  CustomViewComponentProps
> = props => {
  const alertApi = useApi(customAlertApiRef);
  const [customViewError, setCustomViewError] = useState<Error>();

  useEffect(() => {
    if (customViewError) {
      alertApi.post({
        error: new CustomError(
          'Page configuration error',
          'Something went wrong with custom view configuration',
          `${customViewError.message} for ${props.label} `,
        ),
        severity: 'error',
      });
    }
  }, [alertApi, customViewError, props.label]);

  return (
    <MyErrorBoundary onError={setCustomViewError}>
      <CustomViewComponentContent {...props} />
    </MyErrorBoundary>
  );
};
